import script from "./V4CompletedCoursesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./V4CompletedCoursesModal.vue?vue&type=script&setup=true&lang=js"

import "./V4CompletedCoursesModal.vue?vue&type=style&index=0&id=0d06e10c&lang=css"

const __exports__ = script;

export default __exports__